import React from 'react';
import {
  core_apimessages_Money as Money,
} from '../../src/schemas/rql';
import CartApplePayButton from './CartApplePayButton';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';

interface Props {
  checkoutBundlingId: string;
  amountTotal: Money;
  adyenCheckoutPaymentMethodsConfig: string;
}

export function CartBundleFooterApplePayButton(props: Props) {
  const inPaypalButtonRollout = useExpEnabled(experiments.PAYPAL_CHECKOUT_BUTTON);
  const variant = inPaypalButtonRollout ? 'white-outlined-express' : 'white-outlined';

  return (
    <div className="checkout-cart-footer__button checkout-cart-footer__button--apple-pay">
      <CartApplePayButton
        variant={variant}
        checkoutBundlingId={props.checkoutBundlingId}
        amountTotal={props.amountTotal}
        adyenCheckoutPaymentMethodsConfig={props.adyenCheckoutPaymentMethodsConfig}
        tracking={{
          displayStyle: 'default',
        }}
      />
    </div>
  );
}
